import { render } from "./GoalScoringTime.vue?vue&type=template&id=b31317d2&scoped=true"
import script from "./GoalScoringTime.vue?vue&type=script&lang=js"
export * from "./GoalScoringTime.vue?vue&type=script&lang=js"

import "./GoalScoringTime.vue?vue&type=style&index=0&id=b31317d2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b31317d2"]])

export default __exports__